/**
 * StaffStatsData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffStatsData
 */
export interface StaffStatsData {
  /** 角色数量 */
  role_count?: number
}

/**
 * StaffStatsData Schema
 */
export const StaffStatsDataSchema: SchemaDefinition = {
  properties: {
    role_count: {
      description: '角色数量',
      format: 'int',
      type: 'integer',
      label: '角色数量',
    },
  },
  type: 'object',
}
